(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aliuor-accessories-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aliuor-upsell')) {
customElements.define('aliuor-upsell',class extends HTMLElement {
connectedCallback() {
this.track=this.querySelector('.aliuor-upsell__track');
this.prev=this.querySelector('[data-upsell-prev]');
this.next=this.querySelector('[data-upsell-next]');
this.onClick ||= e=>{
const button=e.target.closest('[data-upsell-prev],[data-upsell-next]');
if (!button) return;
const card=this.track.firstElementChild;
const direction=getComputedStyle(this).direction==='rtl'?-1:1;
this.track.scrollBy({left:(card.getBoundingClientRect().width+10)*direction*(button===this.next?1:-1),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
};
this.update ||= ()=>{
const offset=Math.abs(this.track.scrollLeft);
this.prev.disabled=offset<2;
this.next.disabled=offset+this.track.clientWidth>=this.track.scrollWidth-2;
};
this.addEventListener('click',this.onClick);
this.track.addEventListener('scroll',this.update,{passive:true});
this.resize=new ResizeObserver(this.update);
this.resize.observe(this.track);
this.update();
}
disconnectedCallback() { this.removeEventListener('click',this.onClick); this.track?.removeEventListener('scroll',this.update); this.resize?.disconnect(); }
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aliuor-empty-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aliuor-cart-popular')) {
customElements.define('aliuor-cart-popular', class extends HTMLElement {
connectedCallback() {
this.addEventListener('click', event => { if(event.target.closest('[data-popular-retry]')) this.load(); });
this.load();
}
async load() {
if (this.loading) return;
this.loading = true;
this.querySelector('[data-popular-error]').hidden = true;
this.querySelector('[role="status"]').hidden = false;
try {
const response = await fetch(this.dataset.url, {credentials:'same-origin'});
if (!response.ok) throw new Error('Request failed');
const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
const content = doc.querySelector('[data-cart-bestsellers]');
if (!content) throw new Error('Missing content');
if (!content.querySelector('.aliuor-upsell__card')) {
content.querySelector('.aliuor-upsell__track')?.remove();
content.querySelector('.aliuor-upsell__nav')?.remove();
content.querySelector('[data-popular-unavailable]').hidden = false;
}
this.replaceChildren(...content.childNodes);
} catch {
this.querySelector('[role="status"]').hidden = true;
this.querySelector('[data-popular-error]').hidden = false;
} finally { this.loading = false; }
}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aliuor-see-more"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aliuor-load-more')) {
customElements.define('aliuor-load-more', class extends HTMLElement {
connectedCallback() {
this.onClick ||= event => {
const link=event.target.closest('[data-see-more]');
if (!link || !this.contains(link) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
event.preventDefault();
if (!this.busy) this.load(link);
};
this.addEventListener('click',this.onClick);
}
disconnectedCallback() { this.removeEventListener('click',this.onClick); this.controller?.abort(); }
async load(link) {
const grid=this.querySelector('[id="'+this.dataset.gridId+'"]');
const status=this.querySelector('[data-more-status]');
if (!grid) return;
this.busy=true;
link.setAttribute('aria-disabled','true');
grid.setAttribute('aria-busy','true');
status.textContent=status.dataset.loading;
this.controller=new AbortController();
try {
const url=new URL(link.href,location.origin);
url.searchParams.set('section_id',this.dataset.section);
const response=await fetch(url,{signal:this.controller.signal});
if (!response.ok) throw new Error('Request failed');
const doc=new DOMParser().parseFromString(await response.text(),'text/html');
const fresh=doc.getElementById(this.dataset.gridId);
if (!fresh || !fresh.children.length) throw new Error('No products returned');
const items=[...fresh.children];
const next=fresh.closest('aliuor-load-more').querySelector('[data-see-more]');
items.forEach(item=>{
item.style.setProperty('--pg-index',grid.children.length);
grid.append(item);
const owner=this.closest('aliuor-product-grid');
if (owner?.observer) owner.observer.observe(item);
});
status.textContent=status.dataset.loaded;
if (next) { link.href=next.href; link.removeAttribute('aria-disabled'); } else { link.remove(); }
items[0].querySelector('h3 a, a:not([aria-hidden="true"]), button')?.focus({preventScroll:true});
} catch(error) {
if (error.name!=='AbortError') { status.textContent=status.dataset.error; link.removeAttribute('aria-disabled'); }
} finally { this.busy=false; grid.removeAttribute('aria-busy'); }
}
});
}
  } catch(e) { console.error(e); }
})();

})();
